import {XhrService} from "../../ts/xhr.service";
import {addErrorClass, addLoadingClass, removeLoadingClass} from "../utilities/updateClasses";
import {showModal} from "../modal";
import {initLiveSearch} from "../liveSearch";
import {initFormSubmitClicks} from "../actionClick";

let customerListModalLoading = false;

export function loadCustomerListModal(target = false){
    if(document.getElementById("salesPersonSwitchModal")){
        let modal = document.getElementById("salesPersonSwitchModal");
        showModal(modal, function(){
            if(target){
                removeLoadingClass(target);
            }
            let input = modal.querySelector(".js-liveSearchInput");
            if(input){
                input.focus();
                initLiveSearch(modal.querySelectorAll('.js-liveSearch'));
                initFormSubmitClicks(modal.querySelectorAll(".js-formSubmitClick"));
            }
        });
    }else{
        if(customerListModalLoading) return;
        customerListModalLoading = true;
        XhrService.generalAjaxCall('getCustomerListModal', new FormData(), 'POST', 'json').then(response => {
            if (!response.status) {
                throw "Could not save data";
            }
            if(response.html){
                let docResponse = new DOMParser().parseFromString(response.html, "text/html");
                let modal = docResponse.getElementById("salesPersonSwitchModal");
                if(modal){
                    document.body.appendChild(modal);
                    showModal(modal,function (){
                        if(target){
                            removeLoadingClass(target);
                        }
                        let input = modal.querySelector(".js-liveSearchInput");
                        if(input){
                            input.focus();
                            initLiveSearch(modal.querySelectorAll(".js-liveSearch"));
                            initFormSubmitClicks(modal.querySelectorAll(".js-formSubmitClick"));
                        }
                    });
                }
            }
            customerListModalLoading = false;
            return response.status;
        })
            .catch((e) => {
                customerListModalLoading = false;
                if(target){
                    addErrorClass(target);
                }
                console.error('Error:', e);
            });
    }
}

export function triggerCustomerListModal(cssselector = 'js-showCustomerListModal') {
    if (document.customerListModalInitialized) {
        return;
    }
    document.addEventListener('click', function (e) {
        let target = false;
        if(e.target.classList.contains(cssselector)){
            target = e.target;
        }
        if(e.target.closest("a") && e.target.closest("a").classList.contains(cssselector)){
            target = e.target.closest("a");
        }
        if(e.target.closest("."+cssselector)){
            target = e.target.closest("."+cssselector);
        }
        if (target) {
            addLoadingClass(target);
            loadCustomerListModal(target);
        }
    });
    document.customerListModalInitialized = true;
}